(function () {
  var KEY = 'ml-diwali-gate-v1';
  var gate = document.querySelector('.ml-gate');
  var root = document.documentElement;

  if (!gate || !root.classList.contains('ml-gate-pending')) {
    if (gate) gate.remove();
    root.classList.remove('ml-gate-pending');
    return;
  }

  document.body.appendChild(gate);

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var stopSky = null;
  var closed = false;

  if (!reduceMotion) {
    stopSky = startCrackers(gate.querySelector('.ml-gate__sky'));
  }

  var enter = gate.querySelector('.ml-gate__enter');
  if (enter) enter.focus({ preventScroll: true });

  gate.addEventListener('click', function (event) {
    if (event.target.closest('[data-ml-close]')) {
      closeGate();
      return;
    }
    if (!event.target.closest('.ml-gate__card')) closeGate();
  });

  document.addEventListener('keydown', onKey);
  window.setTimeout(closeGate, 4000);

  function onKey(event) {
    if (event.key === 'Escape') closeGate();
  }

  function closeGate() {
    if (closed) return;
    closed = true;
    gate.classList.add('is-leaving');
    root.classList.remove('ml-gate-pending');
    document.removeEventListener('keydown', onKey);
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    if (stopSky) stopSky();
    window.setTimeout(function () { gate.remove(); }, 460);
  }

  function startCrackers(canvas) {
    if (!canvas) return function () {};
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var width = 0;
    var height = 0;
    var sparks = [];
    var rockets = [];
    var raf = 0;
    var running = true;
    var colors = ['#ffd27a', '#ff8a3d', '#fff4d6', '#bf570a', '#ff5d73', '#f2e2c4'];

    function resize() {
      width = canvas.clientWidth;
      height = canvas.clientHeight;
      canvas.width = Math.max(1, Math.floor(width * dpr));
      canvas.height = Math.max(1, Math.floor(height * dpr));
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function burst(x, y, color) {
      var count = 32 + Math.floor(Math.random() * 16);
      var ink = color || colors[Math.floor(Math.random() * colors.length)];
      for (var i = 0; i < count; i++) {
        var angle = (Math.PI * 2 * i) / count + Math.random() * 0.25;
        var speed = 1.1 + Math.random() * 3.4;
        sparks.push({
          x: x,
          y: y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          life: 1,
          decay: 0.01 + Math.random() * 0.016,
          color: ink,
          size: 1.2 + Math.random() * 1.7
        });
      }
    }

    function launch() {
      rockets.push({
        x: width * (0.18 + Math.random() * 0.64),
        y: height + 8,
        vx: (Math.random() - 0.5) * 0.7,
        vy: -(4.2 + Math.random() * 2.8),
        color: colors[Math.floor(Math.random() * colors.length)]
      });
    }

    function frame() {
      if (!running) return;
      ctx.clearRect(0, 0, width, height);
      ctx.globalCompositeOperation = 'lighter';

      if (rockets.length < 4 && Math.random() < 0.045) launch();

      for (var i = rockets.length - 1; i >= 0; i--) {
        var rocket = rockets[i];
        rocket.x += rocket.vx;
        rocket.y += rocket.vy;
        rocket.vy += 0.028;
        ctx.globalAlpha = 0.9;
        ctx.fillStyle = rocket.color;
        ctx.fillRect(rocket.x, rocket.y, 2, 9);
        if (rocket.vy > -0.6) {
          burst(rocket.x, rocket.y, rocket.color);
          rockets.splice(i, 1);
        }
      }

      for (var j = sparks.length - 1; j >= 0; j--) {
        var spark = sparks[j];
        spark.x += spark.vx;
        spark.y += spark.vy;
        spark.vy += 0.03;
        spark.vx *= 0.992;
        spark.life -= spark.decay;
        if (spark.life <= 0) {
          sparks.splice(j, 1);
          continue;
        }
        ctx.globalAlpha = Math.max(spark.life, 0);
        ctx.fillStyle = spark.color;
        ctx.beginPath();
        ctx.arc(spark.x, spark.y, spark.size, 0, Math.PI * 2);
        ctx.fill();
      }

      ctx.globalAlpha = 1;
      raf = window.requestAnimationFrame(frame);
    }

    resize();
    window.addEventListener('resize', resize);
    window.setTimeout(function () {
      burst(width * 0.78, height * 0.18, '#ffd27a');
      burst(width * 0.16, height * 0.22, '#ff8a3d');
      burst(width * 0.62, height * 0.12, '#fff4d6');
    }, 200);
    launch();
    window.setTimeout(launch, 700);
    raf = window.requestAnimationFrame(frame);

    return function stop() {
      running = false;
      window.cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
    };
  }
})();
